import SimpleCrud from "./SimpleCrud";

const EMPTY = { trailer_number: "", trailer_type: "Dry Van", length_ft: 53, status: "available", notes: "" };
const FIELDS = [
  { key: "trailer_number", label: "Trailer #" },
  { key: "trailer_type", label: "Type" },
  { key: "length_ft", label: "Length (ft)", type: "number" },
  { key: "status", label: "Status" },
  { key: "notes", label: "Notes", textarea: true },
];

export default function Trailers() {
  return <SimpleCrud title="Trailers" endpoint="trailers" testid="trailers-admin" empty={EMPTY} fields={FIELDS} />;
}
